import { isWeekend } from 'date-fns'

import { cn } from '@fortem-monorepo/js-utilities'
import { FiltersProvider } from '@fortem-monorepo/react-spa'
import { HeaderConfigBar } from '@fortem-monorepo/react-spa'
import { DateRangePicker, Label, Switch } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { Spinner } from '@fortem-monorepo/react-ui'

import { Page } from '@/components/Page'
import { FUNDS } from '@/constants/links'
import { ICReportSection } from '@/pages/funds/ic-report/components/ICReportSection'
import { ICReportSidebar } from '@/pages/funds/ic-report/components/ICReportSidebar'
import { icReportFilters, useICReportFilters } from '@/pages/funds/ic-report/filters'
import { ICReportProvider } from '@/pages/funds/ic-report/ic-report-context'
import { useICStreamContext } from '@/pages/funds/ic-report/ic-report-context.context'

export interface ICReportPageProps {}

export const ICReportPage: React.FC<ICReportPageProps> = ({}) => {
  return (
    <Page metadata={{ title: 'IC Report' }} permissions={FUNDS.IC_REPORT.permissions}>
      <FiltersProvider filters={icReportFilters}>
        <ICReportProvider>
          <ICReport />
        </ICReportProvider>
      </FiltersProvider>
    </Page>
  )
}

export interface ICReportProps {}

export const ICReport: React.FC<ICReportProps> = ({}) => {
  const { fundsQuery, funds, params, inputsDisabled, sidebarLoading, filteredSections } =
    useICStreamContext()

  const { values, setValue, registerFilter } = useICReportFilters()

  return (
    <div className="flex flex-1">
      <ICReportSidebar sections={filteredSections} loading={sidebarLoading} />
      <div
        className={cn('relative flex flex-col flex-1', {
          ['h-full']: sidebarLoading,
        })}
      >
        <HeaderConfigBar sticky>
          <div className="flex items-center gap-2">
            <div className="space-y-2">
              <Label>Dates</Label>
              <DateRangePicker
                date={{
                  from: values.dates?.st_dt,
                  to: values.dates?.ed_dt,
                }}
                setDate={(dates) =>
                  setValue('dates', {
                    st_dt: dates.from,
                    ed_dt: dates.to,
                  })
                }
                disabled={(date) => isWeekend(date)}
                size="sm"
                buttonDisabled={inputsDisabled}
                calendar={{
                  weekStartsOn: 1,
                  modifiersClassNames: { weekend: 'bg-red-200 rounded-md!' },
                }}
              />
            </div>
            <div className="space-y-2">
              <Label>Fund</Label>
              <SearchSelect
                disabled={inputsDisabled}
                size="sm"
                placeholder={'Select a fund...'}
                value={values.fund_name}
                loading={fundsQuery.isFetching}
                setValue={(val) => setValue('fund_name', val)}
                options={funds.map((fund) => ({
                  label: fund.fund_name,
                  value: fund.fund_name,
                }))}
              />
            </div>
            <div className="space-y-2">
              <Label>Force Month End</Label>
              <Switch {...registerFilter('force_month_end')} />
            </div>
          </div>
        </HeaderConfigBar>
        {sidebarLoading && (
          <div className="absolute top-0 w-full h-full left-0 flex items-center justify-center">
            <Spinner className={'size-10 -mt-20'} />
          </div>
        )}
        {!sidebarLoading && (
          <div className={'-mt-px'}>
            {filteredSections.map((section) => {
              return <ICReportSection section={section} params={params} key={section.key} />
            })}
          </div>
        )}
      </div>
    </div>
  )
}
